import { toast } from 'react-toastify'
import { getTranslate } from 'react-localize-redux'

export default class Notify {
  static error(msgkey, obj) {
     return (dispatch,getState) => {
      let translate =  getTranslate(getState()['localeReducer'])
      let msg = msgkey
      if(obj){
        msg = translate(msgkey, obj)
      }else{
        msg= translate(msgkey)
      }
      toast.error(msg, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      });
    }
  }
  static success(msgkey, obj) {
    return (dispatch,getState) => {
      let translate =  getTranslate(getState()['localeReducer'])
      let msg = msgkey
      if(obj){
        msg = translate(msgkey, obj)
      }else{
        msg= translate(msgkey)
      }
      toast.success(msg, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notifyActions.js